module.exports = __webpack_public_path__ + "static/media/geolocator_white.fd7368a0.png";